import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { CharterDAO } from '../../../../core/services/dao/charterDAO';
import { ActivatedRoute, Router } from '@angular/router';
import { CaptainDAO } from '../../../../core/services/dao/captainDAO';
import { VesselDAO } from '../../../../core/services/dao/vesselDAO';
import { getUtcCharterDate } from '../../../../core/models/charter';
import { Charter } from 'anchor-shared/lib/model/entity/charter';
import { getBoatCaptCrewTotalFromOriginalRates } from 'anchor-shared/lib/service/pure-functions/vessel-helper/vessel-rate-helper';
import {
  generateDiscountPromoOnCharter,
  getAddOnCost,
  getAddOnsTotal,
} from 'anchor-shared/lib/service/pure-functions/charter-pricing/charter-pricing-helper';

import {
  CharterPayoutRequest,
  PayoutDAO,
} from '../../../../core/services/dao/payoutDAO';
import { NumberFormatterService } from '../../../../core/services/number.formatter.service';
import { Observable, Subject } from 'rxjs';
import { DialogsService } from '../../../../core/services/dialog.service';
import { CrewMember } from 'anchor-shared/lib/model/entity/crewMember';
import { CrewMemberDAO } from '../../../../core/services/dao/crewMemberDAO';
import * as moment from 'moment';
import { Moment } from 'moment';
import { ConstantMan } from '../../../../core/services/constantMan';
import { AppCalendarComponent } from '../../../shared/calendar/app-calendar.component';
import { CalendarOptions } from '../../../../core/models/interface/calendar-options';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  RatePayee,
  VesselRate,
} from 'anchor-shared/lib/model/entity/vessel-rate';
import { VesselRateCalculationService } from '../../../../core/services/vessel-rate-calculation-service';
import { VesselRateDAO } from '../../../../core/services/dao/vesselRateDAO';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { Payout } from 'anchor-shared/lib/model/entity/payout';
import { User } from 'anchor-shared/lib/model/entity/user';
import {
  getRoundedFullPaymentAmount,
  incrementBaseFeeForDefaultCrewAdditions,
} from '../../../../core/pure-functions/charter-pricing-helpers';
import { map, startWith, take } from 'rxjs/operators';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { Subscription } from 'rxjs/Rx';
import { AppMessagingService } from '../../../../core/services/app-messaging.service';
import { ChickenTestDialogService } from '../../../shared/dialogs/chicken-test-dialog/chicken-test-dialog.service';
import { Payment } from 'anchor-shared/lib/model/entity/payment';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';
import { WaterBodyDAO } from '../../../../core/services/dao/waterBodyDAO';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { CharterVesselAvailabilityDAO } from '../../../../core/services/dao/charterVesselAvailabilityDAO';
import { ProductOffering } from 'anchor-shared/lib/model/entity/productOffering';
import { UserSearchDialogService } from '../../../shared/dialogs/user-search-dialog/user-search-dialog-service';
import { CaptainGigDAO } from '../../../../core/services/dao/captainGigDAO';
import { RateType } from 'anchor-shared/lib/model/enum/vessel-rate-types';
import * as intlTelInput from 'intl-tel-input';
import { VesselAvailabilityDAO } from '../../../../core/services/dao/VesselAvailabilityDAO';
import { CustomerDAO } from '../../../../core/services/dao/customerDAO';
import { PaymentDAO } from '../../../../core/services/dao/paymentDAO';
import { BuyflowProductOffering } from 'anchor-shared/lib/model/interface/buyflowProductOffering';
import { StripePaymentDAO } from '../../../../core/services/dao/stripePaymentDAO';
import { UserSearchResult } from 'anchor-shared/lib/model/interface/userSearchResult';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { IndividualCost } from '../../../../core/models/interface/additional-cost';
import uuid from 'uuid';
import {
  AddOn,
  AddOnUnitType,
  RequiredAddOnUnitType,
} from 'anchor-shared/lib/model/entity/addOn';
import { roundToNearestCent } from 'anchor-shared/lib/service/utils/helper';
import { concat } from 'rxjs';
import { PaymentProcessor } from 'anchor-shared/lib/model/enum/payment-processor';
import { getPromoAmountFromCharter } from '../../../../core/pure-functions/promo-codes/promo-code-helper';
import { PaymentType } from 'anchor-shared/lib/model/enum/payment-type';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
})
export class EditCharterComponent
  implements OnInit, OnDestroy, AfterViewInit, ContainsSubscriptions
{
  @ViewChild('intlTelInput') private _inputElement!: ElementRef;
  private _intlTelInput: any;
  public E164PhoneNumber!: string | null;
  @ViewChild(AppCalendarComponent)
  appCalendarComponent: AppCalendarComponent;
  charter: Charter;
  charterId: number;
  charterForm: FormGroup;
  numOfServices = [];
  numOfDiscounts = [];
  numOfCrew = [];
  numOfPassengers = [];
  numOfPassengersModified: boolean = false;
  captains: Captain[];
  boats: Vessel[];
  crew = [];
  date: string;
  durationRadio: string;
  showAllocationWarning = false;
  startTimeMeridian: string;
  customDuration = 0;
  calendarOptions: CalendarOptions;
  filteredVessels: Observable<Vessel[]>;
  filteredCaptains: Observable<Captain[]>;
  filteredCrew: Observable<CrewMember[]>;
  currentSelectedCrew: any = null;
  services: any[] = [];
  discounts = [{ name: '', amount: undefined, show: true }];
  model: any;
  selectedBoat: Vessel;
  selectedVesselWaterBodies: WaterBody[];
  selectedVesselCaptains: Captain[];
  crewMembers: any[];
  ownerId: number;
  crewToDelete: any[] = [];
  timeRegEx = /([0-9]|0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])/;
  currencyMask: any;
  captainPayout: boolean;
  selectedCaptain: Captain;
  submittedForm = false;
  charterDateFormatSpecification = 'MM-DD-YYYY';
  editedPayouts = [];
  boatChange = false;
  captainChange = false;
  durationChange = false;
  addOnsChange = false;
  crewChange = false;
  crewIdsToIgnore = [];
  showApprovedCaptains = true;
  subs: Subscription[] = [];
  calendarBoatChange = new Subject<number>();
  preferredCaptains: any[] = [];
  waterBody: WaterBody;
  charterTimezone: string;
  charterPayoutRequest: CharterPayoutRequest;
  payoutResponse: Payout[];
  payoutIdsToDelete: number[];
  payoutsPreviouslyPublished: boolean;
  agreementShouldUpdate = false;
  pageLoaded = false;
  user: any;
  manualPayouts: Payout[];
  suggestedCharterTotal: number;
  originalDate: string;
  originalVessel: number;
  depositPayment: Payment;
  fullPayment: Payment;
  private dateChange: boolean;
  isMobile: boolean;

  constructor(
    private charterDao: CharterDAO,
    private router: Router,
    private route: ActivatedRoute,
    private captainDao: CaptainDAO,
    private boatDao: VesselDAO,
    private payoutDao: PayoutDAO,
    private dialogService: DialogsService,
    private crewMemberDao: CrewMemberDAO,
    private cd: ChangeDetectorRef,
    private numFormatter: NumberFormatterService,
    private snackBar: MatSnackBar,
    private vesselRateCalculationService: VesselRateCalculationService,
    private vesselRateDAO: VesselRateDAO,
    private userDAO: UserDAO,
    private appMessagingService: AppMessagingService,
    private chickenTestDialog: ChickenTestDialogService,
    private waterBodyDAO: WaterBodyDAO,
    private charterVesselAvailabilityDAO: CharterVesselAvailabilityDAO,
    private userSearchDialogService: UserSearchDialogService,
    private captainGigDAO: CaptainGigDAO,
    private vesselAvailabilityDAO: VesselAvailabilityDAO,
    private paymentDAO: PaymentDAO,
    private stripePaymentDAO: StripePaymentDAO,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.charterId = this.route.snapshot.params.id;
    const routeSub = this.route.data.subscribe((data) => {
      this.captains = data.charter.captainResolve;
      this.sortCaptains(this.captains);
      this.boats = data.charter.boatResolve;
      this.crewMembers = data.charter.crewMemberResolve.map((member) => {
        return { id: member.id, user: member.user };
      });
      this.charter = this.model = data.charter.charterResolve;
      this.originalDate = this.charter.date;
      this.originalVessel = this.charter.vesselId;
      if (typeof this.model['numOfPassengers'] === 'string') {
        this.model['numOfPassengers'] = parseInt(this.model['numOfPassengers']);
      }
      this.model.initialNumOfPassengers = this.model.numOfPassengers;
      this.model.initialBoat = this.model.boat;
      data.charter.boatResolve.map((boat) => {
        if (boat.id === this.charter.boat.id) {
          this.selectedBoat = boat;
          if (this.selectedBoat.fuelIncluded) {
            this.model.fuelCost = 0;
          } else {
            if (!this.charter.fuelCost) {
              this.model.fuelCost = this.selectedBoat.fuelBillingRate;
            }
          }
        }
      });
      this.suggestListPriceIfFromBuyflow();
      this.crew = this.numFormatter.parseArrayFromJson(this.charter.crew);
      if (this.crew) {
        this.crew = this.crew.map((member: Partial<CrewMember>) => {
          // Reformat member object if charter was made before R35
          if (!member.user) {
            member = {
              id: member.id,
              // @ts-ignore
              user: {
                id:
                  this.crewMembers.find(({ id }) => id === member.id).user.id ||
                  null,
                firstName: member.user.firstName,
                lastName: member.user.lastName,
                email: member.user.email,
                phoneNumber: member.user.phoneNumber,
                paypalEmail: member.user.email,
              },
            };
          }
          return member;
        });
        this.crew.forEach((member) => this.crewIdsToIgnore.push(member.id));
        this.crewMembers = this.crewMembers.filter(
          (member) => !this.crewIdsToIgnore.includes(member.id),
        );
      }
      this.services = this.numFormatter.parseArrayFromJson(
        this.charter.services,
      );
      if (this.discounts == null) {
        this.discounts = [];
      } else {
        this.discounts = this.numFormatter.parseArrayFromJson(
          this.charter.discounts,
        );
        this.initDiscounts();
      }
      if (this.charter.captain && this.charter.captain.id) {
        const captainSub = this.captainDao
          .getById(this.charter.captain.id)
          .subscribe((captain) => {
            this.selectedCaptain = captain;
          });
        this.subs.push(captainSub);
      }
      if (this.charter.waterBodyId) {
        const waterBodySub = this.waterBodyDAO
          .getByWaterBodyId(this.charter.waterBodyId)
          .subscribe((waterBody) => {
            this.waterBody = waterBody;
            this.charterTimezone = waterBody.timezone.replace(/_/g, ' ');
          });
        this.subs.push(waterBodySub);
      }
      this.customDuration = this.charter.duration;
      this.suggestedCharterTotal = this.charter.charterBaseFee;
      this.startTimeMeridian = this.charter.startTime
        .toLowerCase()
        .includes('pm')
        ? 'pm'
        : 'am';
      this.charter.startTime = this.charter.startTime.replace(/[a-zA-Z]/g, '');
      this.durationRadio = this.getDuration();
      this.captainPayout = this.checkForCaptainPayout();
      this.charter.payouts.forEach((payout) => {
        if (payout.type === 'manual') {
          this.manualPayouts.push(payout);
        }
      });
      this.date = getUtcCharterDate(this.charter).format(
        this.charterDateFormatSpecification,
      );
      this.initPassengers();
      this.initPayments();
      this.currencyMask = this.numFormatter.createPriceMask();
      this.createCalendarOptions();
      this.loadUsersInBackground();
      this.loadSelectedVesselWaterBodies(this.selectedBoat);
      this.loadSelectedVesselCaptains(this.selectedBoat);
    });
    this.subs.push(routeSub);
    this.charterPayoutRequest = {
      charterId: this.charterId,
      captainChangeId: null,
      durationChangeValue: null,
      crewMemberIds: [],
      createFromScratch: false,
      date: null,
    };
    this.payoutResponse = [];
    this.payoutIdsToDelete = [];
    this.user = {};
    this.manualPayouts = [];
    this.searchFxn = this.searchFxn.bind(this);

    const breakpointSub = this.breakpointObserver
      .observe(['(min-width: 960px)'])
      .subscribe((state: BreakpointState) => {
        this.isMobile = !state.matches;
      });
  }

  openSnackbar(message: string) {
    this.snackBar.open(message, null, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }

  private loadUsersInBackground(): void {
    const sub = this.userDAO.load().subscribe((_) => {});
    this.subs.push(sub);
  }

  get intlTelInput(): any {
    return this._intlTelInput;
  }

  get internationalPhoneNumber(): string {
    return this.model.customerPhoneNumber;
  }

  set internationalPhoneNumber(value: string) {
    if (!!value && this._intlTelInput) {
      this._intlTelInput.setNumber(value);
    }
    this.model.customerPhoneNumber = value;
    this.i18nizePhoneNumber();
  }

  public i18nizePhoneNumber(): void {
    this.E164PhoneNumber = null;
    if (this._intlTelInput && this._intlTelInput.isValidNumber()) {
      this.E164PhoneNumber = this._intlTelInput.getNumber();
    }
  }

  hasInvalidPhoneNumber(): boolean {
    if (this._intlTelInput && this._intlTelInput.isValidNumber()) {
      return false;
    }
    return true;
  }

  public loadSelectedVesselWaterBodies(boat: Vessel): void {
    let waterBodiesIds = boat.vesselWaterBodyMap.map((wb) => wb.waterBodyId);
    const wbSub = this.waterBodyDAO
      .getWaterBodiesForVessel(waterBodiesIds)
      .subscribe((waterBodies) => {
        this.selectedVesselWaterBodies = waterBodies;
      });
    this.subs.push(wbSub);
  }

  public loadSelectedVesselCaptains(boat: Vessel): void {
    let captainsIds = boat.vesselCaptainMap.map((captain) => captain.captainId);
    const wbSub = this.captainDao
      .loadCaptainsByIds(captainsIds)
      .subscribe((captains) => {
        this.selectedVesselCaptains = captains;
      });
    this.subs.push(wbSub);
  }

  private createCalendarOptions(): void {
    this.calendarOptions = {
      eventLimit: false,
      timezone: false,
      displayEventTime: false,
      defaultDate: getUtcCharterDate(this.charter).format('MM/DD/YYYY'),
      events: null,
    };
  }

  parseArrayFromJson(json: string): Array<any> {
    // todo remove replace this.numFormatter
    let isString = true;
    let el = JSON.parse(json) as any;
    while (isString) {
      el = JSON.parse(el);
      if (typeof el !== 'string') {
        isString = false;
      }
    }
    return el as Array<any>;
  }

  agreementChangesMade(): void {
    if (
      this.pageLoaded &&
      !this.charter.signedAgreementUrl &&
      this.charter.agreementUrl
    ) {
      this.agreementShouldUpdate = true;
    }
  }

  checkForCaptainPayout() {
    let captainPayout = false;
    this.charter.payouts.forEach((payout) => {
      if (payout.type === 'captain') {
        captainPayout = true;
      }
    });
    return captainPayout;
  }

  removeCrewMember(id) {
    this.crewChange = true;
    this.agreementChangesMade();
    this.crew = this.crew.filter((member) => {
      if (member.id === id) {
        this.crewToDelete.push(member.id);
      }
      return member.id !== id;
    });

    this.charter.crew = JSON.stringify(this.crew);

    this.charterPayoutRequest.crewMemberIds = [];
    if (this.crew) {
      this.crew.forEach((crewMember) => {
        this.charterPayoutRequest.crewMemberIds.push(crewMember.id);
      });
    }

    this.updateCharterPricing();
  }

  ngOnInit() {
    this.charterForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required]),
      phoneNumber: new FormControl('', [Validators.required]),
      numOfPassengers: new FormControl('', []),
      crewFirstName: new FormControl('', []),
      crewLastName: new FormControl('', []),
      date: new FormControl('', [Validators.required]),
      startTime: new FormControl('', [
        Validators.pattern(this.timeRegEx),
        Validators.required,
      ]),
      startTimeMeridian: new FormControl('', [Validators.required]),
      duration: new FormControl('', [Validators.required]),
      customDuration: new FormControl('', []),
      boat: new FormControl('', []),
      boatName: new FormControl('', [Validators.required]),
      boatMake: new FormControl('', [Validators.required]),
      boatModel: new FormControl('', [Validators.required]),
      boatOwnerFirstName: new FormControl('', [Validators.required]),
      boatOwnerLastName: new FormControl('', [Validators.required]),
      boatOwnerEmail: new FormControl('', [Validators.required]),
      captain: new FormControl('', []),
      crew: new FormControl('', []),
      boatOwnerPhone: new FormControl('', [Validators.required]),
      captainFirstName: new FormControl('', [Validators.required]),
      captainLastName: new FormControl('', [Validators.required]),
      captainEmail: new FormControl('', [Validators.required]),
      captainPhoneNumber: new FormControl('', [Validators.required]),
      charterTotal: new FormControl('', [Validators.required]),
      fuelCostPerGallon: new FormControl({ value: '', disabled: true }, [
        Validators.required,
      ]),
    });
    this.cd.detectChanges();
    this.filteredVessels = this.charterForm.controls.boat.valueChanges.pipe(
      startWith(''),
      map((name) => this.filterVessels(name)),
    );
    this.filteredCaptains = this.charterForm.controls.captain.valueChanges.pipe(
      startWith(''),
      map((name) => this.filterCaptains(name)),
    );
    this.filteredCrew = this.charterForm.controls.crew.valueChanges.pipe(
      startWith(''),
      map((name) => this.filterCrew(name)),
    );
    this.vesselRateDAO.loadForVessel(this.charter.boat.id).subscribe();
    if (this.crew) {
      this.crew.forEach((crewMember) => {
        this.charterPayoutRequest.crewMemberIds.push(crewMember.id);
      });
    }
    this.model.itinerary = this.numFormatter.parseJsonIfString(
      this.model.itinerary,
    );
    const intlTelInputInstance = intlTelInput;
    this._intlTelInput = intlTelInputInstance(
      this._inputElement.nativeElement,
      { preferredCountries: ['us', 'mx'] },
    );
    this.validateDate = this.validateDate.bind(this);
  }

  ngAfterViewInit(): void {
    this.pageLoaded = true;
  }

  filterVessels(val: string): Vessel[] {
    return this.boats.filter((s) => new RegExp(val, 'gi').test(s.name));
  }

  filterCaptains(val: string): Captain[] {
    return this.captains.filter((s) =>
      new RegExp(val, 'gi').test(s.user.firstName + ' ' + s.user.lastName),
    );
  }

  filterCrew(val: string): CrewMember[] {
    return this.crewMembers.filter((s) =>
      new RegExp(val, 'gi').test(s.user.firstName + ' ' + s.user.lastName),
    );
  }

  initServices() {
    let i = 0;
    while (i < 20) {
      if (this.services && this.services.length === 0) {
        this.services.push({ name: '', cost: undefined, show: true });
      }
      this.numOfServices.push(i);
      if (!this.services[i]) {
        this.services.push({ name: '', cost: undefined, show: false });
      }
      i++;
    }
  }

  initDiscounts() {
    let i = 0;
    if (this.discounts === null || undefined) {
      this.discounts = [];
    }
    while (i < 20) {
      if (this.discounts && this.discounts.length === 0) {
        this.discounts.push({ name: '', amount: undefined, show: true });
      }
      this.numOfDiscounts.push(i);
      if (!this.discounts[i]) {
        this.discounts.push({ name: '', amount: undefined, show: false });
      }
      i++;
    }
  }

  initPassengers() {
    let i = 1;
    while (i < 14) {
      this.numOfPassengers.push(i);
      i++;
    }
  }

  initPayments() {
    this.charter.payments.forEach((payment) => {
      if (payment.type === PaymentType.DEPOSIT) {
        this.depositPayment = payment;
      }
      if (payment.type === PaymentType.FULL) {
        this.fullPayment = payment;
      }
    });
  }

  selectBoat(event, boat: Vessel) {
    if (event.isUserInput) {
      const boatSub = this.boatDao.loadById(boat.id).subscribe((foundBoat) => {
        const vessel = foundBoat;
        this.model.boat = foundBoat;
        this.calendarBoatChange.next(vessel.id);
      });
      this.subs.push(boatSub);
      this.boatChange = true;
      this.agreementShouldUpdate = true;
      this.model['vesselId'] = boat.id;
      this.model.boatName = boat.name;
      this.model.boatMake = boat.make;
      this.model.boatModel = boat.model;
      this.model.boatOwnerFirstName = boat.owner.user.firstName;
      this.model.boatOwnerLastName = boat.owner.user.lastName;
      this.model.boatOwnerEmail = boat.owner.user.email;
      this.model.boatOwnerPhone = boat.owner.user.phoneNumber;
      if (this.charter.boat.id === boat.id) {
        this.model.itinerary.rulesOfTheBoat = boat.instructionsAndRules;
        this.model.itinerary.parkingInstructions = boat.parkingNotes;
      }
      if (this.charter.boat.id !== boat.id) {
        this.model.itinerary.sent = '';
        this.model.itinerary.captainNotes = boat.specialInstructions;
        this.model.itinerary.rulesOfTheBoat = boat.instructionsAndRules;
        this.model.itinerary.parkingInstructions = boat.parkingNotes;
      }
      this.charterForm.value.boat = boat;
      this.charterForm.value.boatName = boat.name;
      this.charterForm.value.boatMake = boat.make;
      this.charterForm.value.boatModel = boat.model;
      this.selectedBoat = boat;
      this.loadSelectedVesselWaterBodies(this.selectedBoat);
      this.loadSelectedVesselCaptains(this.selectedBoat);
      this.ownerId = boat.ownerId;
      this.charterForm.controls.boat.reset('');
      if (this.selectedBoat.fuelIncluded) {
        this.model.fuelCost = 0;
      } else {
        this.model.fuelCost = boat.fuelBillingRate;
      }
      this.model.depositAmount = boat.depositAmount;
      this.model.waterBodyId = null;
      if (boat.mooringLocation.parkingLat && boat.mooringLocation.parkingLong) {
        let latlongObj = {
          mapLatitude: boat.mooringLocation.parkingLat,
          mapLongitude: boat.mooringLocation.parkingLong,
        };
        const latlongSub = this.waterBodyDAO
          .findClosestWaterBodyToLatLong(latlongObj)
          .subscribe((waterBody) => {
            this.model.waterBodyId = waterBody.id;
          });
        this.subs.push(latlongSub);
      } else if (boat.vesselWaterBodyMap && boat.vesselWaterBodyMap.length) {
        this.model.waterBodyId = boat.vesselWaterBodyMap[0].waterBody?.id;
      }
    }
    const extraGuestFee = this.getAndSetExtraGuestFee([this.model.boat.addOns]);
    this.model.pricingMetaData;
    this.updateCharterPricing();
    this.checkForMatchingProducts();
  }

  selectCaptain(event, captain: Captain, bypass?: boolean) {
    if (event.isUserInput || bypass) {
      this.agreementChangesMade();
      this.captainChange = true;
      const firstName = captain.user.firstName;
      const lastName = captain.user.lastName;
      const email = captain.user.email;
      const phoneNumber = captain.user.phoneNumber;
      this.selectedCaptain = captain;
      this.model.captainId = captain.id;
      this.charterPayoutRequest.captainChangeId = captain.id;
      this.model.captainFirstName = firstName;
      this.model.captainLastName = lastName;
      this.model.captainEmail = email;
      this.model.captainPhoneNumber = phoneNumber;
      this.charterForm.value.captain = captain;
      this.charterForm.value.captainFirstName = firstName;
      this.charterForm.value.captainLastName = lastName;
      if (this.charter.captain && this.charter.captain.id !== captain.id) {
        this.model.itinerary.sent = '';
      }
    }
  }

  searchFxn(searchText): Observable<UserSearchResult[]> {
    return this.userDAO.adminUserSearch(searchText);
  }

  userSearchClick(): void {
    const sub = this.userSearchDialogService
      .open({ searchFxn: this.searchFxn, userType: 'Customers' })
      .subscribe((userSelection) => {
        if (userSelection) {
          if (this.model.userId != userSelection.id) {
            this.paymentDAO
              .removePaymentIntent(this.model.id)
              .subscribe(() => {});
          }
          this.model.customerEmail = userSelection.email;
          this.model.customerFirstName = userSelection.firstName;
          this.model.customerLastName = userSelection.lastName;
          this.model.customerPhoneNumber = userSelection.phoneNumber;
          this.model.userId = userSelection.id;
          this.model.agreementUrl = null;
          this.model.signedAgreementUrl = null;
          this.model.agreementUploadDate = null;
          this.model.agreementSignedDate = null;
          this.model.agreementCreatedDate = null;
          this.agreementShouldUpdate = true;
          this.snackBar.open('Customer has been changed.', null, {
            duration: 4000,
            verticalPosition: 'top',
          });
        }
      });
    this.subs.push(sub);
  }

  selectCrewMember(event, member: CrewMember) {
    if (event.isUserInput) {
      this.currentSelectedCrew = member;
    }
  }

  addCrewMember() {
    this.crewChange = true;
    this.agreementChangesMade();
    this.crew.push(this.currentSelectedCrew);
    this.charterPayoutRequest.crewMemberIds.push(this.currentSelectedCrew.id);
    this.crewIdsToIgnore.push(this.currentSelectedCrew.id);
    this.crewMembers = this.crewMembers.filter(
      (crewMember) => crewMember.id !== this.currentSelectedCrew.id,
    );
    this.charter.crew = JSON.stringify(this.crew);
    this.currentSelectedCrew = null;
    this.charterForm.controls.crew.reset('');
    this.updateCharterPricing();
  }

  increaseDiscountNum() {
    let done;
    this.discounts.forEach((el) => {
      if (!el.show && !done) {
        el.show = true;
        done = true;
      }
    });
  }

  openCrewModal() {
    const dialogSub = this.dialogService.CreateCrewMember().subscribe((res) => {
      if (res) {
        // make crew a userId
        const crewUser = {
          password: 'resetyourpassword',
          email: res.crewMember.email,
          paypalEmail: res.crewMember.paypalEmail,
          firstName: res.crewMember.firstName,
          lastName: res.crewMember.lastName,
          phoneNumber: res.crewMember.phoneNumber,
          city: res.crewMember.city,
          state: res.crewMember.state,
          zip: res.crewMember.zip,
          street: res.crewMember.mailingAddress,
          username: res.crewMember.email,
        };
        this.enroll(crewUser);
      }
    });
    this.subs.push(dialogSub);
  }

  async enroll(crewMember: any) {
    await this.userDAO.checkForUserId(crewMember.email).subscribe((user) => {
      if (user) {
        const crewData = {
          userId: user.id,
        };
        this.onEnrolledCrew(crewData);
        this.userDAO.addRoleToExistingUser('Crew', crewData.userId).subscribe();
        this.snackBar.open(
          'User, ' +
            user.firstName +
            ' ' +
            user.lastName +
            ', with this email already exists. Added crew role.',
        );
      } else if (user === null) {
        const userCreationSub = this.userDAO
          .enrollCrewUser(crewMember)
          .subscribe(
            (createdUser: User) => {
              createdUser.password = crewMember.password;
              const crewData: Partial<CrewMember> = {
                userId: createdUser.id,
              };
              this.onEnrolledCrew(crewData);
              this.snackBar.open('Created Crew Member');
            },
            () => {
              this.snackBar.open('user enrollment failed');
            },
          );
        this.subs.push(userCreationSub);
      }
    });
  }

  onEnrolledCrew(crewData: any) {
    this.crewMemberDao.addCrewMemberToUser(crewData).subscribe((crew) => {
      this.crewMembers.push({ id: crew.id, user: crew.user });
      this.filteredCrew = this.charterForm.controls.crew.valueChanges.pipe(
        startWith(''),
        map((name) => this.filterCrew(name)),
      );
    });
  }

  cancel() {
    this.router.navigate(['manage', 'manage-charter', this.charter.id]);
  }

  sortCaptains(captains) {
    captains.sort((a, b) => {
      if (a.user.lastName.toLowerCase() < b.user.lastName.toLowerCase()) {
        return -1;
      }
      if (a.user.lastName.toLowerCase() > b.user.lastName.toLowerCase()) {
        return 1;
      }
      return 0;
    });
  }

  public hasUnavailable(event): void {
    this.snackBar.open(
      'Vessel unavailable.  You can edit the vessel availability in vessel management.',
      null,
      {
        duration: 5000,
        verticalPosition: 'top',
        panelClass: ['orange-snackbar'],
      },
    );
  }

  public hasAllocations(event): void {
    this.showAllocationWarning = true;
  }

  public validateDate(date) {
    const nowStr = moment().format('YYYY-MM-DD');
    if (moment(nowStr).isSameOrBefore(date.startStr)) {
      return true;
    } else {
      this.snackBar.open('Charter date must be in the future.', null, {
        duration: 4000,
        verticalPosition: 'top',
        panelClass: ['orange-snackbar'],
      });
      return false;
    }
  }

  public selectedDate(event: Moment): void {
    this.date = event.format(this.charterDateFormatSpecification);
    this.dateChange = true;
    this.agreementChangesMade();
    this.updateCharterPricing();
    this.checkForMatchingProducts();
  }

  public selectedEvent(eventInfo: any): void {
    this.dialogService.HelpDialog(eventInfo.dialogInfo);
  }

  public deleteEvent(): void {
    this.appCalendarComponent.deleteByTitle(
      ConstantMan.APP_CALENDAR.CHARTER_PLACEHOLDER,
    );
    this.showAllocationWarning = false;
    this.date = '';
  }

  getDuration(): string {
    let duration;
    switch (this.charter.duration) {
      case 4:
        duration = 'halfDayDuration';
        break;
      case 8:
        duration = 'fullDayDuration';
        break;
      default:
        duration = 'custom';
        break;
    }
    return duration;
  }

  setModelDurationValue(): void {
    switch (this.durationRadio) {
      case 'halfDayDuration':
        this.model.duration = 4;
        break;
      case 'fullDayDuration':
        this.model.duration = 8;
        break;
      default:
        this.model.duration = this.customDuration;
        break;
    }
  }

  setDateAndTimes() {
    this.setModelDurationValue();
    const momentTime = this.getTimeMoment();

    this.model.date = moment
      .utc(this.date, this.charterDateFormatSpecification)
      .set({
        hour: momentTime.get('hour'),
        minute: momentTime.get('minute'),
      });
    this.model.charterEndTime = getUtcCharterDate(this.model)
      .add(this.model.duration, 'hours')
      .format('h:mm a');
    this.model.startTime =
      this.model.startTime.trim() + ' ' + this.startTimeMeridian.toUpperCase();
    this.charterPayoutRequest.durationChangeValue = this.model.duration;
  }

  private getTimeMoment(): Moment {
    return moment(this.model.startTime + ' ' + this.startTimeMeridian, [
      'h:mm A',
    ]);
  }

  durationRadioChange(): void {
    this.setModelDurationValue();
    this.durationChange = true;
    this.charterPayoutRequest.durationChangeValue = this.model.duration;
    this.agreementChangesMade();
    this.updateCharterPricing();
    this.checkForMatchingProducts();
  }

  customHoursChange(): void {
    this.durationChange = true;
    this.setModelDurationValue();
    this.charterPayoutRequest.durationChangeValue = this.model.duration;
    this.agreementChangesMade();
    const vesselSub = this.vesselRateDAO
      .getByVesselId(this.selectedBoat.id)
      .subscribe((vesselRates) => {
        const currentRates = getCurrentVesselRates(vesselRates, this.model);
        this.suggestListPrice(currentRates);
      });
    this.subs.push(vesselSub);
    this.updateCharterFetchNewRates();
    // this.editedPayouts = this.createMockPayoutArray();
  }

  displayPriceDetails(): void {
    const charterForPriceDetails = this.charter;

    this.dialogService.CharterPriceDetailDialog(
      'all',
      [],
      this.getDurationTypeForCalcService(),
      charterForPriceDetails.duration,
      charterForPriceDetails.boat,
      charterForPriceDetails.discounts,
      this.services,
      this.isMobile,
      charterForPriceDetails.originalRates,
      charterForPriceDetails,
      false,
    );
  }

  updateExtraGuestAddOn(e) {
    const addOns = this.model.pricingMetaData?.addOns;
    const extraGuestAddOn = [...addOns, ...this.model.boat.addOns]?.find(
      (x) => x.unitType === RequiredAddOnUnitType.PER_PERSON_ABOVE_LIMIT,
    );

    const passengerCount = parseInt(e.target.value);
    if (extraGuestAddOn) {
      const additionalExtraGuestCount =
        passengerCount -
        (extraGuestAddOn.minQuantity + (extraGuestAddOn?.quantity || 0));
      extraGuestAddOn.quantity =
        (extraGuestAddOn?.quantity || 0) + additionalExtraGuestCount;
      const guestFeeIdx = this.model.pricingMetaData?.addOns?.findIndex(
        (x) => x.id === extraGuestAddOn.id,
      );
      this.model.pricingMetaData.addOns[guestFeeIdx] = extraGuestAddOn;
    }
  }

  manageAdjustmentPaymentFromCharter(charter) {
    return new Observable((observer) => {
      this.paymentDAO
        .getPaymentsByCharterId(charter.id)
        .subscribe((payments) => {
          const [fullAndAddOnPaymentTotal, paidPaymentTotal] = payments.reduce(
            ([full, paid], curr) => {
              const amount = parseFloat(curr.amount);
              if (
                [PaymentType.FULL, PaymentType.ADJUSTMENT].includes(curr.type)
              ) {
                full += amount;
                if (curr.paid) {
                  paid += amount;
                }
              }
              if (curr.type === PaymentType.REFUND) {
                full -= amount;
                paid -= amount;
              }
              return [full, paid];
            },
            [0, 0],
          );

          const { discountsTotal } = this.calculateDiscounts();
          const promoAmount = getPromoAmountFromCharter(charter);
          charter.discountTotal = discountsTotal;
          const newBoatFullAndAddOnPrice = parseFloat(
            getRoundedFullPaymentAmount(charter, promoAmount),
          );

          const unpaidAdjustmentPayment = payments.find(
            (x) => x.type === PaymentType.ADJUSTMENT && !x.paid,
          );
          const adjustmentDiff = newBoatFullAndAddOnPrice - paidPaymentTotal;
          const adjustmentPrice =
            adjustmentDiff > 0 ? roundToNearestCent(adjustmentDiff) : 0;

          if (
            unpaidAdjustmentPayment &&
            fullAndAddOnPaymentTotal !== newBoatFullAndAddOnPrice
          ) {
            if (adjustmentPrice === 0) {
              // if adjustment payment will be set to zero, delete it instead
              this.paymentDAO
                .deletePayment(unpaidAdjustmentPayment.id)
                .subscribe((success) => {
                  observer.next(!!success);
                  observer.complete();
                });
            } else {
              // update amount of adjustment payment to include entire charter adjustment
              const paymUpdateSub = this.paymentDAO
                .updateFromPartial(unpaidAdjustmentPayment.id, {
                  amount: `${adjustmentPrice}`,
                })
                .subscribe((success) => {
                  if (adjustmentDiff < 0) {
                    this.openSnackbar(
                      "The customer's payment is greater than the cost of the charter now. Be sure to check to see if the customer needs to be refunded.",
                    );
                  }
                  observer.next(!!success);
                  observer.complete();
                });
              this.subs.push(paymUpdateSub);
            }
          } else if (fullAndAddOnPaymentTotal < newBoatFullAndAddOnPrice) {
            // create payment intent of dif
            const adjustmentPaymentData: Payment = {
              type: PaymentType.ADJUSTMENT,
              name: 'Charter edit - Price increase',
              paid: false,
              notes: 'charter price adjustment',
              amount: `${adjustmentPrice}`,
              charterId: charter.id,
              transactionCreatedAt: moment().utc().format('YYYY-MM-DD HH:mm'),
              processor: PaymentProcessor.STRIPE,
            };
            this.paymentDAO
              .createPayment(adjustmentPaymentData)
              .subscribe((payment) => {
                this.openSnackbar(
                  'The charter price has increased. Be sure to finalize the payment for the additional cost.',
                );
                observer.next(true);
                observer.complete();
              });
          } else {
            if (paidPaymentTotal > newBoatFullAndAddOnPrice) {
              this.openSnackbar(
                'The total price of this charter has decreased since the customer paid. Be sure to check to see if the customer needs to be refunded.',
              );
            }
            observer.next(true);
            observer.complete();
          }
        });
    });
  }

  getAndSetExtraGuestFee(addOns) {
    const extraGuestFee = addOns?.find(
      (x) => x.unitType === RequiredAddOnUnitType.PER_PERSON_ABOVE_LIMIT,
    );
    if (
      extraGuestFee &&
      !extraGuestFee.quantity &&
      extraGuestFee.quantity !== 0
    ) {
      const additionalExtraGuestCount =
        this.model.numOfPassengers -
        (extraGuestFee.minQuantity + (extraGuestFee?.quantity || 0));
      extraGuestFee.quantity =
        (extraGuestFee?.quantity || 0) + additionalExtraGuestCount;
    }
    return extraGuestFee;
  }

  openAddOnSelection() {
    this.handleAddOnSelection().subscribe((selectedAddOns) => {
      this.model.pricingMetaData.addOns = selectedAddOns;
    });
  }

  handleAddOnSelection(showChickenTest = false) {
    return new Observable<AddOn[]>((observer) => {
      const openDialog = () => {
        const addOns = this.model.boat?.addOns.map((addOn) => {
          const existingAddOn = this.model.pricingMetaData?.addOns?.find(
            (x) => x.id === addOn.id,
          );
          return existingAddOn || addOn;
        });

        const optionalAddOns = addOns.filter((x) => !x.required);

        const extraGuestFee = this.getAndSetExtraGuestFee(addOns);
        const requiredAddOnsTotal = extraGuestFee
          ? getAddOnsTotal([extraGuestFee], null, true)
          : 0;

        const dialogRef = this.dialogService.CustomerAddOnsDialog(
          optionalAddOns,
          this.suggestedCharterTotal,
          requiredAddOnsTotal,
          null,
          null,
          this.model.duration,
          this.isMobile,
          false,
        );

        dialogRef.afterClosed().subscribe((selectedAddOns) => {
          if (selectedAddOns) {
            this.addOnsChange = true;

            const updatedAddOns = [...selectedAddOns];

            if (extraGuestFee) {
              updatedAddOns.push(extraGuestFee);
            }
            observer.next(updatedAddOns);
            observer.complete();
          }
        });
      };

      if (showChickenTest) {
        const boatUpdateChickenTest = this.chickenTestDialog
          .open(
            "Add ons for this charter have been affected. Please confirm the customer's add-ons.",
            'Manage add-ons',
            'Submit without add-ons',
            60,
            null,
            null,
            null,
            null,
            true,
          )
          .subscribe((submit) => {
            if (submit) {
              const { addOns: boatAddOns } = this.model.boat;
              if (!boatAddOns?.length) {
                observer.next([]);
                observer.complete();
              }

              openDialog();
            } else {
              observer.next([]);
              observer.complete();
            }
          });
        this.subs.push(boatUpdateChickenTest);
      } else {
        openDialog();
      }
    });
  }

  handleCharterPaymentUpdate(type: PaymentType, newAmount) {
    return new Observable((observer) => {
      const paymSub = this.paymentDAO
        .getPaymentsByCharterId(this.charter.id)
        .subscribe((payments) => {
          if (payments.length > 0) {
            const fullPayment = payments.find((payment) => {
              return payment.type === type && !payment.paid;
            });
            if (fullPayment) {
              const paymUpdateSub = this.paymentDAO
                .updateFromPartial(fullPayment.id, {
                  amount: newAmount,
                })
                .subscribe((success) => {
                  if (success) {
                    observer.next(true);
                  } else {
                    this.openSnackbar('Failed to update payment amount');
                    observer.next(false);
                  }
                  observer.complete();
                });
              this.subs.push(paymUpdateSub);
            }
          } else {
            const promoAmount = getPromoAmountFromCharter(this.charter);
            const fullPaymentPrice = getRoundedFullPaymentAmount(
              this.charter,
              promoAmount,
            );
            const fullPaymentData: Payment = {
              type: PaymentType.FULL,
              name: 'Full Payment',
              paid: false,
              amount: `${fullPaymentPrice}`,
              charterId: this.charter.id,
              transactionCreatedAt: moment().utc().format('YYYY-MM-DD HH:mm'),
              processor: PaymentProcessor.STRIPE,
            };
            this.paymentDAO
              .createPayment(fullPaymentData)
              .subscribe((payment) => {
                this.openSnackbar(
                  'The charter price has increased. Be sure to finalize the payment for the additional cost.',
                );
                observer.next(true);
                observer.complete();
              });
          }
        });
      this.subs.push(paymSub);
    });
  }

  handlePreSubmission() {
    // handle all checks and chicken tests prior to submission
    return new Observable((observer) => {
      const setGuestFeeAndHandleAdjustment = () => {
        this.model.pricingMetaData.addOns = [];

        const extraGuestFee = this.getAndSetExtraGuestFee(
          this.model.boat?.addOns,
        );
        if (extraGuestFee) {
          this.model.pricingMetaData.addOns.push(extraGuestFee);
        }

        if (this.charter.remainderStatus === 'PAID') {
          const addOnUpdatedCharter = { ...this.charter };
          addOnUpdatedCharter.pricingMetaData.addOns =
            this.model.pricingMetaData.addOns;
          this.manageAdjustmentPaymentFromCharter(
            addOnUpdatedCharter,
          ).subscribe((success) => {
            observer.next(!!success);
            observer.complete();
          });
        }
        observer.next(true);
        observer.complete();
      };

      if (this.model.vesselId !== this.model.initialBoat.id) {
        const optionalAddOns =
          this.model.boat?.addOns.filter((x) => !x.required) || [];
        if (optionalAddOns.length > 0) {
          this.handleAddOnSelection(true).subscribe((addOns) => {
            if (addOns.length) {
              this.model.pricingMetaData.addOns = addOns;

              if (this.charter.remainderStatus === 'PAID') {
                const addOnUpdatedCharter = { ...this.charter };
                addOnUpdatedCharter.pricingMetaData.addOns = addOns;
                this.manageAdjustmentPaymentFromCharter(
                  addOnUpdatedCharter,
                ).subscribe((success) => {
                  observer.next(!!success);
                  observer.complete();
                });
              } else {
                const promoAmount = getPromoAmountFromCharter(this.charter);
                const newFullPaymentPrice = getRoundedFullPaymentAmount(
                  this.charter,
                  promoAmount,
                );
                this.handleCharterPaymentUpdate(
                  PaymentType.FULL,
                  newFullPaymentPrice,
                ).subscribe((success) => {
                  observer.next(!!success);
                  observer.complete();
                });
              }
            } else {
              setGuestFeeAndHandleAdjustment();
            }
          });
        } else {
          setGuestFeeAndHandleAdjustment();
          observer.next(true);
          observer.complete();
        }
      } else if (
        (this.charter.remainderStatus === 'PAID' && this.addOnsChange) ||
        this.model.numOfPassengers !== this.model.initialNumOfPassengers
      ) {
        const addOnUpdatedCharter = { ...this.charter };
        addOnUpdatedCharter.pricingMetaData.addOns =
          this.model.pricingMetaData.addOns;
        this.manageAdjustmentPaymentFromCharter(addOnUpdatedCharter).subscribe(
          (success) => {
            observer.next(!!success);
            observer.complete();
          },
        );
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  }

  async submit() {
    const canSubmit = await this.handlePreSubmission().first().toPromise();

    if (!canSubmit) {
      return;
    }

    this.submittedForm = true;
    this.setDateAndTimes();
    if (this.E164PhoneNumber) {
      this.model.customerPhoneNumber = this.E164PhoneNumber;
    }

    this.charter.fuelCost = this.numFormatter.unMaskPrice(
      this.charter.fuelCost,
    );

    this.addCaptainToPreferredCheck();
    this.model['date'] = new Date(this.model['date']);
    this.charter.charterBaseFee = this.numFormatter.unMaskPrice(
      this.charter.charterBaseFee,
    );
    this.charter.depositAmount = this.numFormatter.unMaskPrice(
      this.charter.depositAmount,
    );
    let crew;
    crew = this.crew.map((member) => {
      if (member.new) {
        delete member.new;
      }
      return member;
    });
    const { discounts, discountsTotal } = this.calculateDiscounts();
    this.model.crew = crew;
    this.model.services = this.charter.services;
    this.model.discounts = discounts;
    this.model.serviceTotal = this.charter.serviceTotal;
    this.model.discountTotal = discountsTotal;

    if (this.boatChange) {
      this.model.agreementSignedDate = null;
      this.model.signedAgreementUrl = null;
      this.model.agreementUrl = null;
    }

    if (this.charter.pricingMetaData.promoCode) {
      // recalculate promo
      this.charter = generateDiscountPromoOnCharter(
        this.charter,
        this.charter.pricingMetaData.promoCode,
      );
    }
    this.charterDao
      .updateFromPartial(this.charter.id, {
        vesselId: this.model.vesselId,
        charterBaseFee: this.model.charterBaseFee,
        userId: this.model.userId,
        customerFirstName: this.model.customerFirstName,
        customerLastName: this.model.customerLastName,
        customerEmail: this.model.customerEmail,
        customerPhoneNumber: this.model.customerPhoneNumber,
        numOfPassengers: this.model.numOfPassengers,
        crew: this.model.crew,
        date: this.model.date,
        startTime: this.model.startTime,
        charterEndTime: this.model.charterEndTime,
        duration: this.model.duration,
        boatName: this.model.boatName,
        boatMake: this.model.boatMake,
        boatModel: this.model.boatModel,
        boatOwnerFirstName: this.model.boatOwnerFirstName,
        boatOwnerLastName: this.model.boatOwnerLastName,
        boatOwnerEmail: this.model.boatOwnerEmail,
        boatOwnerPhone: this.model.boatOwnerPhone,
        captainId: this.model.captainId,
        captainFirstName: this.model.captainFirstName,
        captainLastName: this.model.captainLastName,
        captainEmail: this.model.captainEmail,
        captainPhoneNumber: this.model.captainPhoneNumber,
        fuelCost: this.model.fuelCost,
        depositAmount: this.model.depositAmount,
        services: this.model.services,
        serviceTotal: this.model.serviceTotal,
        discounts: this.model.discounts,
        discountTotal: this.model.discountTotal,
        itinerary: this.model.itinerary,
        originalRates: this.model.originalRates,
        waterBodyId: this.model.waterBodyId,
        agreementSignedDate: this.model.agreementSignedDate,
        signedAgreementUrl: this.model.signedAgreementUrl,
        agreementUrl: this.model.agreementUrl,
        agreementUploadDate: this.model.agreementUploadDate,
        agreementCreatedDate: this.model.agreementCreatedDate,
        pricingMetaData: this.model.pricingMetaData,
      })
      .subscribe((data) => {
        if (this.charter && this.agreementShouldUpdate === false) {
          this.submittedForm = false;
        }
        if (this.agreementShouldUpdate) {
          const charterAgreementSub = this.charterDao
            .createCharterAgreement(this.charter.id)
            .subscribe(() => {
              this.submittedForm = false;
            });
          this.subs.push(charterAgreementSub);
          this.appMessagingService.openSnack(
            'The charter agreement has changed, please re-send it to the customer to be signed again.',
          );
        }

        if (this.boatChange || this.dateChange) {
          this.vesselAvailabilityDAO
            .updateSingleDayAvailabilityForVessel(
              this.originalVessel,
              this.originalDate,
            )
            .pipe(take(1))
            .subscribe(() => {
              this.vesselAvailabilityDAO
                .updateSingleDayAvailabilityForVessel(
                  this.model.vesselId,
                  moment(this.model.date).format('YYYY-MM-DD'),
                )
                .pipe(take(1))
                .subscribe();
            });
          const gigSyncSub = this.captainGigDAO
            .syncGigsForCharterEdit(this.charterId, this.model.vesselId)
            .subscribe((gigsSynced) => {
              console.log(`New Gigs synced: ${gigsSynced}`);
            });
          this.subs.push(gigSyncSub);

          const depositSub = this.paymentDAO
            .getPaymentsByCharterId(this.charterId)
            .subscribe((payments) => {
              const depositRow = payments.filter(
                (payment) => payment.type === PaymentType.DEPOSIT,
              )[0];
              if (depositRow) {
                const replaceHoldSub = this.stripePaymentDAO
                  .createHoldForBoatChange(
                    depositRow.paymentIntentId,
                    this.model,
                  )
                  .subscribe((data) => {});
                this.subs.push(replaceHoldSub);
              }
            });
          this.subs.push(depositSub);
        }

        if (this.isBigFiveEdit() && this.charterIsFinalized()) {
          this.charterPayoutRequest = this.createCharterPayoutRequest();
          const payoutIdsToDelete: number[] = [];
          const payoutRequestSub = this.payoutDao
            .charterPayoutRequest(this.charterPayoutRequest)
            .subscribe((payouts) => {
              this.charter.payouts.forEach((existingPayout) => {
                if (!existingPayout.paid) {
                  payoutIdsToDelete.push(existingPayout.id);
                }
              });
              const deletePayoutsSub = this.payoutDao
                .deleteMultiple(payoutIdsToDelete)
                .subscribe(() => {
                  const createPayoutsSub = this.payoutDao
                    .createMultiple(payouts)
                    .subscribe((regeneratedPayouts) => {
                      this.charter.payouts = regeneratedPayouts;
                      this.appMessagingService.openSnack(
                        'The charter has been edited after finalization, payouts have been regenerated.',
                      );
                      this.onSaveComplete();
                    });
                  this.subs.push(createPayoutsSub);
                });
              this.subs.push(deletePayoutsSub);
            });
          this.subs.push(payoutRequestSub);
        } else {
          this.onSaveComplete();
        }
      });
  }

  finalizedSubmit(): void {
    if (this.charterIsFinalized() && this.isBigFiveEdit()) {
      const chickenSub = this.chickenTestDialog
        .open(
          'Are you sure you want to save your charter edit? ' +
            'Payouts will be regenerated and you will lose any changes you have made to them.',
          'Yes, continue',
          'Cancel',
          60,
        )
        .subscribe((save) => {
          if (save) {
            this.submit();
          }
        });
      this.subs.push(chickenSub);
    } else {
      this.submit();
    }
  }

  calculateDiscounts(): { discounts: any; discountsTotal: number } {
    let discountsTotal = 0;
    let discounts = [];
    this.discounts.forEach((el) => {
      if (el.name !== '') {
        el.amount = this.numFormatter.unMaskPrice(el.amount);
        discounts.push(el);
        discountsTotal += this.numFormatter.unMaskPrice(el.amount);
      }
    });
    return { discounts, discountsTotal };
  }

  createCharterPayoutRequest(): CharterPayoutRequest {
    let crewIds = [];
    if (this.charter.crew && this.charter.crew.length) {
      this.charter.crew.forEach((crewMember) => {
        crewIds.push(crewMember.id);
      });
    }

    return {
      charterId: this.charter.id,
      captainChangeId: this.selectedCaptain.id,
      durationChangeValue: this.getIntegerFromDurationRadio(),
      crewMemberIds: crewIds,
      createFromScratch: true,
      date: this.model.date,
    };
  }

  onSaveComplete(runAutoFuelAndHoursAutoCalc?: boolean): void {
    if (runAutoFuelAndHoursAutoCalc) {
      this.router.navigate(['manage', 'manage-charter', this.charter.id], {
        queryParams: {
          runFuelAddHours: 1,
          index: 5,
        },
        queryParamsHandling: 'merge',
      });
    } else {
      this.router.navigate(['manage', 'manage-charter', this.charter.id]);
    }
  }

  updateManualPayouts(): void {
    if (this.manualPayouts && (this.boatChange || this.captainChange)) {
      const manualPayoutSub = this.payoutDao
        .updateManualPayouts(
          this.manualPayouts,
          this.selectedCaptain ? this.selectedCaptain.userId : null,
          this.selectedBoat ? this.selectedBoat.owner.userId : null,
        )
        .subscribe();
      this.subs.push(manualPayoutSub);
    }
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  charterIsFinalized(): boolean {
    return (
      this.charter.payouts &&
      this.charter.payouts.length &&
      this.charter.completed
    );
  }

  private suggestListPriceIfFromBuyflow(): void {
    if (
      !this.model.charterBaseFee &&
      this.selectedBoat &&
      this.model.duration
    ) {
      const vesselSub = this.vesselRateDAO
        .getByVesselId(this.selectedBoat.id)
        .subscribe((vesselRates) => {
          const currentRates = getCurrentVesselRates(vesselRates, this.model);
          this.suggestListPrice(currentRates);
        });
      this.subs.push(vesselSub);
    } else {
      this.addServicesCostToBuyFlowSuggestedPrice();
    }
  }

  private resetCharterOriginalRates(currentRates: VesselRate[]): void {
    this.model.originalRates = [];
    currentRates.forEach((rate) => {
      this.model.originalRates.push(rate);
    });
  }

  private suggestListPrice(vesselRates: VesselRate[]): void {
    // todo - remove
    if (this.selectedBoat && this.getIntegerFromDurationRadio()) {
      const hours = this.getIntegerFromDurationRadio();
      const currentPrice = getBoatCaptCrewTotalFromOriginalRates(
        vesselRates,
        this.getDurationTypeForCalcService(),
        this.customDuration,
      );
      this.model.charterBaseFee =
        this.vesselRateCalculationService.getVesselRateTotal(
          vesselRates,
          currentPrice,
          this.getDurationTypeForCalcService(),
          hours,
          this.selectedBoat
            ? this.selectedBoat.fuelIncluded
            : this.model.boat.fuelIncluded,
        );
      const crewRate = this.vesselRateCalculationService.getVesselRate(
        vesselRates,
        RateType.Crew,
      );

      let crewPrice = null;
      if (crewRate) {
        crewPrice = this.vesselRateCalculationService.calculateVesselRate(
          crewRate,
          this.getDurationTypeForCalcService(),
          this.customDuration,
          true,
        );
      }

      const crewRateCount = vesselRates.filter((rate) => {
        return rate.rateType === RateType.Crew;
      }).length;
      incrementBaseFeeForDefaultCrewAdditions(
        this.model,
        this.crew,
        crewRate,
        crewRateCount,
        crewPrice,
        this.getIntegerFromDurationRadio(),
      );

      this.suggestedCharterTotal = this.model.charterBaseFee;
      this.addServicesCostToBuyFlowSuggestedPrice();

      this.snackBar.open('The Charter Suggested Price has been updated', null, {
        duration: 5000,
        verticalPosition: 'top',
      });
    }
  }

  private getIntegerFromDurationRadio(): number {
    let returnHours: number = null;
    switch (this.durationRadio) {
      case 'halfDayDuration':
        returnHours = 4;
        break;
      case 'fullDayDuration':
        returnHours = 8;
        break;
      default:
        returnHours = this.customDuration;
        break;
    }
    return returnHours;
  }

  private getDurationTypeForCalcService(): 0 | 4 | 8 {
    let returnHours: 0 | 4 | 8 = null;
    switch (this.durationRadio) {
      case 'halfDayDuration':
        returnHours = 4;
        break;
      case 'fullDayDuration':
        returnHours = 8;
        break;
      default:
        returnHours = 0;
        break;
    }
    return returnHours;
  }

  updateUserInfo() {
    const question =
      'Are you sure you want to update this user? (Changes will not be saved at the charter level yet.)';
    const affirmativeText = 'Yes, update user';
    const negativeText = 'No, cancel';
    this.chickenTestDialog
      .open(question, affirmativeText, negativeText)
      .subscribe((userResponse) => {
        if (userResponse) {
          const userSub = this.userDAO
            .findUserById(this.model.userId)
            .subscribe((user) => {
              user.firstName = this.model.customerFirstName;
              user.lastName = this.model.customerLastName;
              user.phoneNumber = this.model.customerPhoneNumber;
              user.username = user.email = this.model.customerEmail;
              let roleIds = [];
              user.roles.forEach((role) => {
                roleIds.push(role.id);
              });
              const updateSub = this.userDAO
                .adminUpdateUser(user, roleIds)
                .subscribe((res) => {
                  this.appMessagingService.openSnack('User Updated');
                });
              this.subs.push(updateSub);
            });
          this.subs.push(userSub);
        }
      });
  }

  disableUpdateUserButton(): boolean {
    const controls = this.charterForm.controls;
    return !(
      controls.email.dirty ||
      controls.phoneNumber.dirty ||
      controls.firstName.dirty ||
      controls.lastName.dirty
    );
  }

  addServicesCostToBuyFlowSuggestedPrice(): void {
    this.services.forEach((service) => {
      this.suggestedCharterTotal += this.numFormatter.unMaskPrice(service.cost);
    });
  }

  isBigFiveEdit(): boolean {
    return (
      this.boatChange ||
      this.captainChange ||
      this.crewChange ||
      this.durationChange ||
      this.numOfPassengersModified
    );
  }

  unassignCaptain() {
    this.selectedCaptain = null;
    this.captainChange = true;
    this.model.captain = null;
    this.model.captainEmail = '';
    this.model.captainId = null;
    this.model.captainFirstName = '';
    this.model.captainLastName = '';
    this.model.captainPhoneNumber = '';
    this.model.itinerary.sent = '';
  }

  private addCaptainToPreferredCheck(): void {
    let needToAddCaptain = false;
    this.preferredCaptains = [];
    this.selectedBoat.vesselCaptainMap.forEach((captain) => {
      this.preferredCaptains.push(captain.captainId);
    });
    if (
      this.selectedCaptain &&
      this.preferredCaptains.includes(this.selectedCaptain.id) === false
    ) {
      this.preferredCaptains.push(this.selectedCaptain.id);
      needToAddCaptain = true;
    }
    if (needToAddCaptain) {
      const captainSub = this.boatDao
        .updateVesselCaptains(this.selectedBoat.id, this.preferredCaptains)
        .subscribe((_) => {
          console.log('preferred captain added');
        });
      this.subs.push(captainSub);
    }
  }

  private updateCharterPricing() {
    if (this.boatChange || this.dateChange) {
      this.updateCharterFetchNewRates();
    } else {
      this.updateCharterPricingPreserveOriginalRates();
    }
  }

  private updateCharterFetchNewRates() {
    if (this.date && this.getIntegerFromDurationRadio()) {
      const productRatesSub = this.vesselRateDAO
        .getProductAdjustedRates(
          this.selectedBoat.id,
          this.date,
          this.getIntegerFromDurationRadio(),
        )
        .subscribe((productAdjustedRates) => {
          this.charter.boat.vesselRates = this.charter.originalRates =
            productAdjustedRates.vesselRates;
          this.suggestedCharterTotal = this.model.charterBaseFee =
            productAdjustedRates.charterBaseFee;
          this.addServicesCostToBuyFlowSuggestedPrice();
          this.snackBar.open(
            'The Charter Suggested Price has been updated',
            null,
            {
              duration: 5000,
              verticalPosition: 'top',
            },
          );
        });
      this.subs.push(productRatesSub);
    }
  }

  private updateCharterPricingPreserveOriginalRates() {
    const rateSub = this.vesselRateDAO
      .getByVesselId(this.selectedBoat.id)
      .subscribe((loadedRates) => {
        const currentRates = getCurrentVesselRates(loadedRates, this.model);
        this.suggestListPrice(currentRates);
      });
    this.subs.push(rateSub);
  }

  private checkForMatchingProducts() {
    if (this.date && this.getIntegerFromDurationRadio() !== null) {
      const vesselProductSub = this.charterVesselAvailabilityDAO
        .getAvailableProductsForDay(
          this.selectedBoat.id,
          moment(this.date, this.charterDateFormatSpecification)
            .utc()
            .startOf('day'),
        )
        .subscribe((productValues) => {
          // @ts-ignore
          if (!this.productValuesIncludesSelectedDuration(productValues)) {
            this.model.pricingMetaData = {
              ...this.model.pricingMetaData,
              legacyPricing: true,
              product: null,
            };
            this.snackBar.open(
              'No available products for selected configuration, defaulting to legacy pricing.',
              null,
              {
                duration: 5000,
                verticalPosition: 'top',
              },
            );
          } else {
            this.model.pricingMetaData = {
              ...this.model.pricingMetaData,
              legacyPricing: false,
              product: productValues.filter(
                (product) =>
                  product.duration === this.getIntegerFromDurationRadio(),
              ),
            };
          }
        });

      this.subs.push(vesselProductSub);
    }
  }

  private productValuesIncludesSelectedDuration(
    productValues: BuyflowProductOffering[],
  ) {
    if (productValues && productValues.length) {
      return (
        productValues &&
        productValues.some(
          (product) => product.duration === this.getIntegerFromDurationRadio(),
        )
      );
    }
    return false;
  }
}

export function getCurrentVesselRates(
  vesselRates: VesselRate[],
  charter: Partial<Charter>,
): VesselRate[] {
  return charter.originalRates && charter.originalRates.length > 0
    ? charter.originalRates
    : vesselRates;
}
